import React from 'react';

type SkipLinkTarget = {
  id: string;
  targetName: string;
};

/**
 * This represents the default target for skip links that don't have a special target, like content landmarks or other.
 * This element is visible:none per default, so screen readers don't read them when they are not targeted.
 * Sometimes it's necessary to :focus them instead of :target (see SkipLink, focusTrap in modal dialog).
 */
export function SkipLinkTarget({ id, targetName }: SkipLinkTarget) {
  return <hr id={id} aria-label={targetName} className="skip-link__target" />;
}
